export default class Navigator {
    constructor() {
        this.registerEventListeners();
    }

    registerEventListeners() {
    }
}